import { useHistory } from "react-router-dom";
import * as Styles from "./App.Styles";

import IphoneImage from "assets/images/health-analyse/iphone.png";
import Check from "assets/images/health-analyse/check.svg";

import DashboardImage from "assets/images/health-analyse/dashboard.png";
import BigDashboardImage from "assets/images/health-analyse/big-dashboard.png";

import { useState } from "react";
import MainHeader from "../../../components/Wrapper/HealthAnalyseHeader";
import { BENEFITS } from "routes/routes";
import { useSelector } from "react-redux";
import { IMG_BASE_URL } from "pages/selectCoach/selectCoach";

function HealthAnalyseApp() {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(0);
  const { trainerShowData } = useSelector((state) => state.auth);
  const handleBtnClick = () => {
    history.push(BENEFITS);
  };
  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <Styles.Container>
      <div className="main-div">
        <MainHeader
          headline={"Auswertung"}
          subHeadline={"Alles für deinen Erfolg"}
          handleNextPage={handleBtnClick}
          noBackButton={true}
        />
        <Styles.ContentSection>
          <Styles.Tab>
            <Styles.TabItem
              active={activeTab === 0}
              onClick={() => handleTabClick(0)}
              type="button"
            >
              App
            </Styles.TabItem>
            <Styles.TabItem
              active={activeTab === 1}
              onClick={() => handleTabClick(1)}
              type="button"
            >
              Dashboard
            </Styles.TabItem>
            <Styles.TabItem
              active={activeTab === 2}
              onClick={() => handleTabClick(2)}
              type="button"
            >
              Coach
            </Styles.TabItem>
          </Styles.Tab>
          {/* Mobile View - Keep unchanged */}
          <Styles.MobileView>
            <Styles.TabContentWrapper>
              <Styles.TabContent active={activeTab === 0}>
                {/* Content for App Funktionen */}
                <img
                  src={IphoneImage}
                  alt="App Funktionen"
                  style={{
                    width: "100%",
                    maxWidth: "400px",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
                {appTabData.map((tile) => (
                  <Styles.Tile key={tile.id}>
                    <Styles.Circle>
                      <p>{tile.id}</p>
                    </Styles.Circle>
                    <Styles.ContentDiv>
                      <Styles.RegularTitle>{tile.title}</Styles.RegularTitle>
                      <Styles.Description>
                        {tile.description}
                      </Styles.Description>
                    </Styles.ContentDiv>
                  </Styles.Tile>
                ))}
              </Styles.TabContent>

              <Styles.TabContent active={activeTab === 1}>
                {/* Content for Dashboard */}
                <img
                  src={DashboardImage}
                  alt="Dashboard"
                  style={{
                    width: "100%",
                    maxWidth: "400px",
                    display: "block",
                    margin: "0 auto 32px",
                  }}
                />
                {dashboardTabData.map((tile) => (
                  <Styles.Tile key={tile.id}>
                    <Styles.Circle>
                      <p>{tile.id}</p>
                    </Styles.Circle>
                    <Styles.ContentDiv>
                      <Styles.RegularTitle>{tile.title}</Styles.RegularTitle>
                      <Styles.Description>
                        {tile.description}
                      </Styles.Description>
                    </Styles.ContentDiv>
                  </Styles.Tile>
                ))}
              </Styles.TabContent>

              <Styles.TabContent active={activeTab === 2}>
                {/* Content for Coach */}
                <div className="coachImage">
                  <img
                    src={IMG_BASE_URL + trainerShowData?.profilePic}
                    alt="coachImage"
                  />
                  <Styles.CoachTitle>Ich begleite dich</Styles.CoachTitle>
                  <Styles.CoachName>
                    {trainerShowData?.prename} {trainerShowData?.surname}
                  </Styles.CoachName>
                  <Styles.CoachDescription>
                    Als Trainer und Ernährungsberater für große Fitnessstudios
                    wie Cleverfit und Fitone habe ich schon vor 10 Jahren damit
                    begonnen Menschen die Ernährungsumstellung zu vereinfachen
                    und zahlreiche Ernährungspläne erstellt. Im Jahr 2015 habe
                    ich dafür eine Software entwickelt, mit welchen
                    Fitnessstudios ihre Kunden betreuen können und im Jahr 2020
                    die App von Foodiary gegründet.
                  </Styles.CoachDescription>
                  <ul style={{ listStyle: "none", padding: 0 }}>
                    <Styles.ListItem>
                      <span className="tick-icon">
                        <img src={Check} alt="Check" />
                      </span>
                      <h3 className="bold-text">Coach für: </h3>
                      <p>{trainerShowData?.subtitle}</p>
                    </Styles.ListItem>
                    <Styles.ListItem>
                      <span className="tick-icon">
                        <img src={Check} alt="Check" />
                      </span>
                      <h3 className="bold-text">Ernährungsberater seit: </h3>
                      <p> {trainerShowData?.step2}</p>
                    </Styles.ListItem>
                    <Styles.ListItem>
                      <span className="tick-icon">
                        <img src={Check} alt="Check" />
                      </span>
                      <h3 className="bold-text">Ausbildungen: </h3>
                      <p> {trainerShowData?.step3}</p>
                    </Styles.ListItem>
                  </ul>
                </div>
              </Styles.TabContent>
            </Styles.TabContentWrapper>
          </Styles.MobileView>

          {/* Desktop View - New layout matching the image */}
          <Styles.DesktopView>
            {activeTab == 0 ? (
              <Styles.DesktopAppContent>
                <Styles.DesktopImageColumn>
                  <img
                    src={IphoneImage}
                    alt="App Funktionen"
                    className="app-mockup"
                  />
                </Styles.DesktopImageColumn>
                <Styles.Grid>
                  <Styles.DesktopFeaturesColumn>
                    <Styles.DesktopFeatureTitle>
                      Rezeptfilter mit künstlicher Intelligenz
                    </Styles.DesktopFeatureTitle>
                    <Styles.DesktopFeatureText>
                      Dank künstlicher Intelligenz treffen wir eine Vorauswahl
                      an Rezepten, welche zu deiner Ernährungsform passen und
                      integrieren diese in deinen Tag.
                    </Styles.DesktopFeatureText>
                  </Styles.DesktopFeaturesColumn>
                  <Styles.DesktopFeaturesColumn>
                    <Styles.DesktopFeatureTitle>
                      Plane deine Woche vor
                    </Styles.DesktopFeatureTitle>
                    <Styles.DesktopFeatureText>
                      Deine Woche kannst du einfach vorplanen. So wählst du in
                      deinem Ernährungsplan die Rezepte aus, welche du gerne
                      zubereiten möchtest.
                    </Styles.DesktopFeatureText>
                  </Styles.DesktopFeaturesColumn>
                  <Styles.DesktopFeaturesColumn>
                    <Styles.DesktopFeatureTitle>
                      Optimierung deines Ernährungsplans
                    </Styles.DesktopFeatureTitle>
                    <Styles.DesktopFeatureText>
                      Mithilfe der Empfehlung für Nahrungsergänzungsmittel,
                      welche dir zu den optimalen Zeiten angezeigt wird, kannst
                      du deinen Ernährungsplan weiter optimieren und deine Ziele
                      einfacher erreichen.
                    </Styles.DesktopFeatureText>
                  </Styles.DesktopFeaturesColumn>
                  <Styles.DesktopFeaturesColumn>
                    <Styles.DesktopFeatureTitle>
                      Individuelle Tagesplanung
                      <Styles.DesktopFeatureLabel>
                        PRO
                      </Styles.DesktopFeatureLabel>
                    </Styles.DesktopFeatureTitle>
                    <Styles.DesktopFeatureText>
                      Während des Ernährungsplanes hast du die Möglichkeit
                      verschiedene Tagespläufe auszuwählen. Diese legst du zu
                      Beginn an und kannst diese täglich wechseln oder als
                      wiederkehrende Routine speichern.
                    </Styles.DesktopFeatureText>
                  </Styles.DesktopFeaturesColumn>
                  <Styles.DesktopFeaturesColumn>
                    <Styles.DesktopFeatureTitle>
                      Intelligente Einkaufsliste
                    </Styles.DesktopFeatureTitle>
                    <Styles.DesktopFeatureText>
                      Vorgeplante Rezepte werden automatisch in unsere
                      intelligente Einkaufsliste gelegt. Diese kannst du bequem
                      beim Einkauf abrufen und dir anzeigen lassen, welche
                      Mengen an Lebensmitteln du für die geplante Woche
                      benötigst.
                    </Styles.DesktopFeatureText>
                  </Styles.DesktopFeaturesColumn>
                  <Styles.DesktopFeaturesColumn>
                    <Styles.DesktopFeatureTitle>
                      Dynamische Kalorienanpassung
                      <Styles.DesktopFeatureLabel>
                        PRO
                      </Styles.DesktopFeatureLabel>
                    </Styles.DesktopFeatureTitle>

                    <Styles.DesktopFeatureText>
                      Durch die dynamische Kalorienanpassung gehen wir auf
                      Veränderungen in deinem Stoffwechsel ein. Das ist für dich
                      wichtig, um langfristig dein Ziel zu erreichen.
                    </Styles.DesktopFeatureText>
                  </Styles.DesktopFeaturesColumn>
                </Styles.Grid>
              </Styles.DesktopAppContent>
            ) : activeTab == 1 ? (
              <Styles.DesktopDashboardContent>
                <img src={BigDashboardImage} alt="BigDashboardImage" />
                <Styles.DashboardGrid>
                  <Styles.DesktopFeaturesColumn>
                    <Styles.DesktopFeatureTitle>
                      Kostenrückerstattung
                    </Styles.DesktopFeatureTitle>
                    <Styles.DesktopFeatureText>
                      Die Krankenkasse übernimmt bis zu 100% der Kosten bei
                      unserem digitalen Coaching PLUS.
                    </Styles.DesktopFeatureText>
                  </Styles.DesktopFeaturesColumn>
                  <Styles.DesktopFeaturesColumn>
                    <Styles.DesktopFeatureTitle>
                      12 Wochen Online Kurs
                    </Styles.DesktopFeatureTitle>
                    <Styles.DesktopFeatureText>
                      In 8 Lektionen lernst du die Grundlagen einer gesunden
                      Ernährung kennen. Interaktive Videos mit Handouts und
                      Wissensquiz.
                    </Styles.DesktopFeatureText>
                  </Styles.DesktopFeaturesColumn>
                  <Styles.DesktopFeaturesColumn>
                    <Styles.DesktopFeatureTitle>
                      Lernacademy mit Weeklys
                    </Styles.DesktopFeatureTitle>
                    <Styles.DesktopFeatureText>
                      In E-Books und Artikeln vertiefst du dein Wissen. Bei
                      unseren Weeklys beantwortet dir ein Foodiary Coach alle
                      Fragen.
                    </Styles.DesktopFeatureText>
                  </Styles.DesktopFeaturesColumn>
                </Styles.DashboardGrid>
              </Styles.DesktopDashboardContent>
            ) : (
              <Styles.CoachView>
                <img
                  src={IMG_BASE_URL + trainerShowData?.profilePic}
                  alt="coachImage"
                  className="coachImage"
                />
                <div className="coachContent">
                  <Styles.CoachTitle>Ich begleite dich</Styles.CoachTitle>
                  <Styles.CoachName>
                    {trainerShowData?.prename} {trainerShowData?.surname}
                  </Styles.CoachName>
                  <Styles.CoachDescription>
                    Als Trainer und Ernährungsberater für große Fitnessstudios
                    wie Cleverfit und Fitone habe ich schon vor 10 Jahren damit
                    begonnen Menschen die Ernährungsumstellung zu vereinfachen
                    und zahlreiche Ernährungspläne erstellt. Im Jahr 2015 habe
                    ich dafür eine Software entwickelt, mit welchen
                    Fitnessstudios ihre Kunden betreuen können und im Jahr 2020
                    die App von Foodiary gegründet.
                  </Styles.CoachDescription>
                  <ul style={{ listStyle: "none", padding: 0 }}>
                    <Styles.ListItem>
                      <span className="tick-icon">
                        <img src={Check} alt="Check" />
                      </span>
                      <h3 className="bold-text">Coach für: </h3>
                      <p>{trainerShowData?.subtitle}</p>
                    </Styles.ListItem>
                    <Styles.ListItem>
                      <span className="tick-icon">
                        <img src={Check} alt="Check" />
                      </span>
                      <h3 className="bold-text">Ernährungsberater seit: </h3>
                      <p> {trainerShowData?.step2}</p>
                    </Styles.ListItem>
                    <Styles.ListItem>
                      <span className="tick-icon">
                        <img src={Check} alt="Check" />
                      </span>
                      <h3 className="bold-text">Ausbildungen: </h3>
                      <p> {trainerShowData?.step3}</p>
                    </Styles.ListItem>
                  </ul>
                </div>
              </Styles.CoachView>
            )}
          </Styles.DesktopView>
        </Styles.ContentSection>
      </div>
      <button
        onClick={handleBtnClick}
        className="btn-dark w-full mt-8 btn-show"
      >
        Weiter
      </button>
    </Styles.Container>
  );
}

export default HealthAnalyseApp;

const appTabData = [
  {
    id: 1,
    title: "KI Rezeptfilter",
    description:
      "Durch die Gewinnung von Energie aus Fett benötigt der Körper mehr Kalorien.",
  },
  {
    id: 2,
    title: "Dynamische Einkaufsliste",
    description:
      "Durch die Gewinnung von Energie aus Fett benötigt der Körper mehr Kalorien.",
  },
  {
    id: 3,
    title: "Meal-Prep und Fortschritte",
    description:
      "Durch die Gewinnung von Energie aus Fett benötigt der Körper mehr Kalorien.",
  },
];
const dashboardTabData = [
  {
    id: 1,
    title: "8 Wochen Onlinekurs",
    description:
      "Du wirst Schritt für Schritt durch deine Ernährungsumstellung geleitet.",
  },
  {
    id: 2,
    title: "Gruppencalls und Support",
    description:
      "Experten unterstützen dich in Gruppencalls und dem Austausch.",
  },
  {
    id: 3,
    title: "Handouts & Wissenssammlung",
    description:
      "Wertvolle Tipps & Tricks für einen dauerhaften Erfolg ohne JOJO-Effekt.",
  },
];
